<template>
  <div>
    <h3 class="mt-3 mb-4 mk-fe-businessdetails">Business Details</h3>

    <hr />

    <div class="row">
      <div class="col-6 mw-300">
        <p>Business Type</p>
      </div>
      <div class="col-6">{{ initial_business.business_type ? initial_business.business_type.name: ''}}</div>
    </div>

    <div class="row">
      <div class="col-6 mw-300">
        <p>Legal Entity</p>
      </div>
      <div class="col-6">{{initial_business.name}}</div>
    </div>

    <div class="row">
      <div class="col-6 mw-300">
        <p>ABN</p>
      </div>
      <div class="col-6">{{initial_business.abn}}</div>
    </div>

    <div class="row">
      <div class="col-6 mw-300">
        <p>Registered Business Address</p>
      </div>
      <div class="col-6">{{initial_business.address}}</div>
    </div>

    <div class="row">
      <div class="col-6 mw-300">
        <p>Limit</p>
      </div>
      <div class="col-6">{{initial_business.finance_capacity / 100}}</div>
    </div>

    <div class="row">
      <div class="col-12">
        <h6>Bank Details</h6>
        <hr />
      </div>
    </div>


    <!-- <div class="row">
      <div class="col-6 mw-300">BSB</div>
      <div class="col-6">{{initial_business.bsb}}</div>
    </div> -->

    <!-- <div class="row">
      <div class="col-6 mw-300">Account</div>
      <div class="col-6">{{initial_business.account_number}}</div>
    </div> -->


    <div class="row">
      <div class="col-12">
        <hr />
      </div>
    </div>

    <div class="row">
      <div class="col-6 mw-300">Communication Preferences</div>
      <div class="col-6">
        <el-radio-group class="d-flex flex-column" disabled v-model="initial_business.communication_preference">
          <el-radio label="Post">Post</el-radio>
          <el-radio label="Email">Email</el-radio>
          <el-radio label="SMS">SMS</el-radio>
        </el-radio-group>
      </div>
    </div>


  </div>
</template>
<script>
export default {
  props: {
    initial_business: Object
  },
  data() {
    return {
      //
    };
  }
};
</script>